import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'

import messages from './messages'
import s from './SuccessfullyResubscribedModal.scss'


// TODO remove it and all places were it's used (coz it's never called)
export default class SuccessfullyResubscribedModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    name: constants.modals.resubscribe.SuccessfullyResubscribed,
    title: messages.title,
  }

  constructor() {
    super()

    this.actions = [
      {
        brand: true,
        title: messages.btnTakeScentQuiz,
        onClick: this.handleClick,
      },
      {
        whiteGray: true,
        title: messages.btnExploreOnMyOwn,
        onClick: this.close,
      },
    ]
  }

  handleClick = () => {
    this.close()
    actions.models.router.push(links.quiz)
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ModalWithActions
        name={name}
        title={title}
        actions={this.actions}
        id={name}
      >
        <FormattedHTMLMessage className={s.text} tag="div" {...messages.text} />
      </ModalWithActions>
    )
  }
}
